export default __webpack_public_path__ + "static/SR France - Pesticides - Statement-7d37007fb355a7bada1d2b61e9568fcc.pdf";